(function($) {
  $(document).ready(function(){
    var $nav = $('.full-nav');
    $('#mobile-burger').on('click', function(){
      console.log('lapie');
      $(this).toggleClass('mob-burger--active');
      $nav.toggleClass('full-nav--active');
    });
 
  });
})(jQuery);

